import { getListingTooltip } from 'utils';

const listingTooltip = getListingTooltip() || { registerTooltip: () => {} };

export default function useListingTooltip() {
    return listingTooltip.registerTooltip;
}
